import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Row, Button } from 'reactstrap';
import Swal from 'sweetalert2';
import { CUSTOMER_URL } from '../../../../constants/LocalStorageVariables';
import { getAlertToast } from '../../../../functions/CoreFunctions';
import { JSONParser } from '../../../../functions/Helper';
import { getCustomerToken } from '../../../common/CommonFunctions';
import moment from 'moment';

export default function ChoosePlanBox({ DogId, signInPage }) {
  const { choosePlan = [] } = useSelector((state) => state.ChoosePlanReducer);

  const url = choosePlan.map((i) => i.agencyUrl);
  localStorage.setItem(CUSTOMER_URL, url[0]);

  const token = getCustomerToken();

  const alertSignIn = () => {
    if (!token) {
      Swal.fire(getAlertToast('Success', 'Please sign in'));
    }
  };
  return (
    <>
      <Row className="mt-4 create-plan plan-list">
        {choosePlan.map((record, e) =>
          record.planName ? (
            <Col md="4" className="mb-4" key={e}>
              <div className="box">
                <h4>{record.planName}</h4>
                <h1>
                  <strong>$</strong>
                  {parseFloat(record.planAmount).toFixed(2)}
                </h1>
                <span>
                  {record.isLifeTimePlan && 'Life Time Plan'}

                  {!!record.validTo && (
                    <>
                      {' '}
                      <span>Till Date</span>{' '}
                      {moment(record.validTo).format('MM-DD-YYYY')}
                    </>
                  )}
                  {!!record.planDuration && record.planDuration + '/ month'}
                </span>
                <ul>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17.011"
                      height="17.011"
                      viewBox="0 0 17.011 17.011"
                    >
                      <path
                        id="Icon_material-check-box"
                        data-name="Icon material-check-box"
                        d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                        transform="translate(-4.5 -4.5)"
                        fill="#fff"
                      />
                    </svg>
                    {record.isRenewal ? (
                      <>
                        {' '}
                        Renewal for{' '}
                        {record.isKennelLicense
                          ? 'kennel license'
                          : record.isParkLicense
                          ? 'Park License'
                          : record.isDogLicense
                          ? 'Dog License'
                          : ''}{' '}
                      </>
                    ) : (
                      <>
                        {record.isKennelLicense
                          ? 'kennel license'
                          : record.isParkLicense
                          ? 'Park License'
                          : record.isDogLicense
                          ? 'Dog License'
                          : ''}
                      </>
                    )}
                  </li>
                </ul>
                <p>{record.planDescription}</p>
                {JSONParser(record.categoryDetails, []).map((i) => (
                  <ul>
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17.011"
                        height="17.011"
                        viewBox="0 0 17.011 17.011"
                      >
                        <path
                          id="Icon_material-check-box"
                          data-name="Icon material-check-box"
                          d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                          transform="translate(-4.5 -4.5)"
                          fill="#fff"
                        />
                      </svg>
                      {i.categoryName}
                    </li>
                  </ul>
                ))}

                {token ? (
                  <Link
                    to={{
                      pathname:
                        `/user/chooseplan/` +
                        `${record.licensePlanId}/${DogId}`,
                    }}
                  >
                    <div className="btn-section">
                      <Button
                        disabled={DogId === ''}
                        color="danger"
                        data-licensePlanId={record.licensePlanId}
                        onClick={alertSignIn}
                      >
                        Choose Plan
                      </Button>
                    </div>
                  </Link>
                ) : (
                  <div className="btn-section">
                    <Button
                      disabled={DogId === ''}
                      color="danger"
                      data-licensePlanId={record.licensePlanId}
                      onClick={alertSignIn}
                    >
                      Choose Plan
                    </Button>
                  </div>
                )}
              </div>
            </Col>
          ) : (
            <center>No plan is Active</center>
          )
        )}
      </Row>
    </>
  );
}
